"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _constructor = _interopRequireDefault(require("../../../constants/constructor"));

var _clone = _interopRequireDefault(require("../../utils/clone"));

var _Uri = _interopRequireDefault(require("../../Uri"));

var _extractParts = _interopRequireDefault(require("../../utils/extractParts"));

var _mergePaths = _interopRequireDefault(require("../mergePaths"));

var _mergeQueries = _interopRequireDefault(require("../mergeQueries"));

/* istanbul ignore file */
// constants
// libraries
function convertToUri(uriOrPath) {
  if ("string" === typeof uriOrPath) {
    const {
      path,
      query,
      fragment
    } = (0, _extractParts.default)(uriOrPath);
    return new _Uri.default(null, null, null, null, path, query, fragment);
  } else {
    return uriOrPath;
  }
}

class RouterWithConvinientDecorator {
  [_constructor.default]() {
    this.options = {
      mergeQuery: true
    };
    this.GroupRouter = null;
  }

  get(uriOrPath) {
    const route = new this.Route(["get"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  head(uriOrPath) {
    const route = new this.Route(["head"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  post(uriOrPath) {
    const route = new this.Route(["post"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  put(uriOrPath) {
    const route = new this.Route(["put"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  delete(uriOrPath) {
    const route = new this.Route(["delete"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  connect(uriOrPath) {
    const route = new this.Route(["connect"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  option(uriOrPath) {
    const route = new this.Route(["option"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  trace(uriOrPath) {
    const route = new this.Route(["trace"], convertToUri(uriOrPath));
    this.addRoute(route);
    return route;
  }

  group(baseUri, callback, options = {}) {
    const {
      mergeQuery = this.options.mergeQuery
    } = options;
    baseUri = convertToUri(baseUri);
    const router = new this.GroupRouter();
    callback.call(null, router);

    for (const route of router.getRoutes()) {
      var _uri$getQuery, _uri$getFragment;

      const uri = route.getUri();

      if (null !== uri.getScheme()) {
        throw new ReferenceError("Error in Router.prototype.group, `scheme` attribute must not defined in grouped routes.");
      }

      if (null !== uri.getUserInfo()) {
        throw new ReferenceError("Error in Router.prototype.group, `userInfo` attribute must not defined in grouped routes.");
      }

      if (null !== uri.getHost()) {
        throw new ReferenceError("Error in Router.prototype.group, `host` attribute must not defined in grouped routes.");
      }

      if (null !== uri.getPort()) {
        throw new ReferenceError("Error in Router.prototype.group, `port` attribute must not defined in grouped routes.");
      }

      const mergedUri = new _Uri.default(baseUri.getScheme(), baseUri.getUserInfo(), baseUri.getHost(), baseUri.getPort(), (0, _mergePaths.default)(baseUri.getPath(), uri.getPath()), mergeQuery ? (0, _mergeQueries.default)(baseUri.getQuery(), uri.getQuery()) : (_uri$getQuery = uri.getQuery()) != null ? _uri$getQuery : baseUri.getQuery(), (_uri$getFragment = uri.getFragment()) != null ? _uri$getFragment : baseUri.getFragment());
      const methods = route.getMethods();
      const newRoute = (0, _clone.default)(route, new this.Route());
      newRoute.setMethods(methods);
      newRoute.setUri(mergedUri);
      newRoute.setConstraints({ ...route.getConstraints(),
        ...router.getConstraints()
      });
      this.addRoute(newRoute);
    }
  }

}

exports.default = RouterWithConvinientDecorator;